import './newSections.css';

// ─── Sub-category data (sourced from client UI.xlsx) ──────────────────────────
// Keyed by: categoryId (set) or singleId (single) + pairingId

// For each sub-category, `typeMap` describes what gets selected in the types[] array
// when `submitCloth()` is eventually called.
// types[] = [Kurta(0), Coat(1), Pajama(2), Sadri(3)]

export const SUBCATEGORY_DATA = {

  // ── SET: Kurta Pajama ──────────────────────────────────────────────────────
  'kurta-pajama': {
    heading: 'Start with a Kurta Style',
    subheading: 'Select a base style and begin customizing your outfit',
    // types that get passed to submitCloth for ALL Kurta Pajama sub-categories:
    defaultTypes: [1, 0, 1, 0], // Kurta + Pajama
    items: [
      { id: 'pathani-kurta',       name: 'Pathani Kurta',       hint: 'Afghan collar, side pockets',    badge: null },
      { id: 'designer-kurta',      name: 'Designer Kurta',      hint: 'Embellished, event-ready',        badge: null },
      { id: 'dhoti-kurta',         name: 'Dhoti Kurta',         hint: 'Draped dhoti bottom',             badge: 'Popular' },
      { id: 'kurta-with-coat',     name: 'Kurta with Coat',     hint: 'Nehru jacket layered style',      badge: null,
        // Kurta + Coat + Pajama
        overrideTypes: [1, 1, 1, 0] },
      { id: 'wedding-kurta',       name: 'Wedding Kurta',       hint: 'Heavy embroidery, festive',       badge: 'Eid' },
      { id: 'short-kurta-pajama',  name: 'Short Kurta Pajama',  hint: 'Casual everyday length',          badge: null },
      { id: 'kurta-churidaar',     name: 'Kurta Churidaar',     hint: 'Fitted churidaar bottom',         badge: null },
    ],
  },

  // ── SET: Suit ──────────────────────────────────────────────────────────────
  suit: {
    heading: 'Start with a Suit Style',
    subheading: 'Select a base style and begin customizing your outfit',
    defaultTypes: [1, 0, 1, 0],
    items: [], // coming soon
  },

  // ── SET: Pant Shirt ────────────────────────────────────────────────────────
  'pant-shirt': {
    heading: 'Start with a Pant Shirt Style',
    subheading: 'Select a base style and begin customizing your outfit',
    defaultTypes: [1, 0, 1, 0],
    items: [], // coming soon
  },

  // ── SINGLE: Sadri ──────────────────────────────────────────────────────────
  sadri: {
    heading: 'Choose Your Sadri Style',
    subheading: 'Select a vest style and begin customizing your outfit',
    defaultTypes: [1, 0, 0, 1], // Kurta + Sadri
    items: [
      { id: 'essential-nehru-vest',    name: 'Essential Nehru Vest',    hint: 'Classic Nehru collar design',  badge: null },
      { id: 'heritage-v-vest',         name: 'Heritage V Vest',         hint: 'Deep V-neck heritage style',   badge: null },
      { id: 'officer-vest',            name: 'Officer Vest',            hint: 'Military-inspired formal',     badge: null },
      { id: 'signature-curve-vest',    name: 'Signature Curve Vest',    hint: 'Curved hem signature style',   badge: 'Eid' },
      { id: 'royal-wrap-vest',         name: 'Royal Wrap Vest',         hint: 'Wrap-front royal aesthetic',   badge: null },
      { id: 'classic-lapel-vest',      name: 'Classic Lapel Vest',      hint: 'Notch lapel formal vest',      badge: null },
    ],
  },

  // ── SINGLE: Kurta (alone) ──────────────────────────────────────────────────
  kurta: {
    heading: 'Choose Your Kurta Style',
    subheading: 'Select a base style and begin customizing your outfit',
    defaultTypes: [1, 0, 0, 0], // Kurta only
    items: [
      { id: 'pathani-kurta',        name: 'Pathani Kurta',        hint: 'Afghan collar, side pockets',   badge: null },
      { id: 'embroidery-work',      name: 'Embroidery Work',      hint: 'Hand-crafted thread work',      badge: null },
      { id: 'machine-embroidery',   name: 'Machine Embroidery',   hint: 'Precision machine patterns',    badge: null },
      { id: 'short-kurta',          name: 'Short Kurta',          hint: 'Casual everyday length',        badge: null },
      { id: 'round-neck',           name: 'Round Neck',           hint: 'Minimal round-neck collar',     badge: null },
      { id: 'piping-kurta',         name: 'Piping Kurta',         hint: 'Contrast piping details',       badge: 'Eid' },
      { id: 'eenkar-thread',        name: 'Eenkar Thread',        hint: 'Traditional thread-work',       badge: null },
    ],
  },

  // ── SINGLE: Pajama (alone) ─────────────────────────────────────────────────
  pajama: {
    heading: 'Choose Your Pajama Style',
    subheading: 'Select a pajama style and begin customizing your outfit',
    defaultTypes: [0, 0, 1, 0], // Pajama only
    items: [
      { id: 'patiyala',    name: 'Patiyala',    hint: 'Wide-leg Punjabi style',    badge: null },
      { id: 'dhoti',       name: 'Dhoti',       hint: 'Draped traditional dhoti',  badge: 'Popular' },
      { id: 'salwar',      name: 'Salwar',      hint: 'Classic pleated salwar',    badge: null },
      { id: 'belbootom',   name: 'Belbootom',   hint: 'Flared bell-bottom cut',    badge: null },
      { id: 'churidaar',   name: 'Churidaar',   hint: 'Fitted ankle gathers',      badge: null },
      { id: 'pant',        name: 'Pant',        hint: 'Straight-leg trouser',      badge: null },
      { id: 'pajama',      name: 'Pajama',      hint: 'Classic comfort pajama',    badge: null },
    ],
  },

  // ── SINGLE: Blazer ────────────────────────────────────────────────────────
  blazer: {
    heading: 'Choose Your Blazer Style',
    subheading: 'Select a style and begin customizing your outfit',
    defaultTypes: [1, 1, 0, 0],
    items: [], // coming soon
  },
};

// ─── Image placeholder (replace with real product photos) ────────────────────
// DEVELOPER NOTE: Import your sub-category product images and map them here.
// Format: { [subcategoryId]: importedImage }
// Example:
//   import pathaniImg from '../../assets/subcategories/pathani-kurta.jpg';
//   const SUBCAT_IMAGES = { 'pathani-kurta': pathaniImg, ... };
//
// Until real photos are available, the component renders a styled placeholder.
const SUBCAT_IMAGES = {};

// ─── Component ────────────────────────────────────────────────────────────────

function SubCategorySelector({ contextKey, onSelectSubCategory, selectedSubCategoryId }) {
  const data = SUBCATEGORY_DATA[contextKey];

  if (!data) return null;

  return (
    <section className="cs-subcat-section" id="cs-subcategory-section">
      <div className="cs-container">

        {/* ── Header ── */}
        <div className="cs-subcat-header">
          <div>
            <h2 className="cs-heading">{data.heading}</h2>
            <p className="cs-subheading">{data.subheading}</p>
          </div>
          {data.items.length > 0 && (
            <span className="cs-count">{data.items.length} styles available</span>
          )}
        </div>

        {/* ── Style Grid ── */}
        {data.items.length > 0 ? (
          <div className="cs-subcat-grid">
            {data.items.map((item) => (
              <div
                key={item.id}
                className={`cs-subcat-card ${selectedSubCategoryId === item.id ? 'cs-subcat-card--selected' : ''}`}
                onClick={() => onSelectSubCategory({ ...item, defaultTypes: item.overrideTypes || data.defaultTypes })}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && onSelectSubCategory({ ...item, defaultTypes: item.overrideTypes || data.defaultTypes })}
              >
                {/* Badge */}
                {item.badge && (
                  <div className="cs-subcat-badge">{item.badge}</div>
                )}

                {/* Selected indicator */}
                {selectedSubCategoryId === item.id && (
                  <div className="cs-subcat-selected-mark">✓</div>
                )}

                {/* Image area */}
                <div className="cs-subcat-img-wrap">
                  {SUBCAT_IMAGES[item.id] ? (
                    <img src={SUBCAT_IMAGES[item.id]} alt={item.name} className="cs-subcat-img" />
                  ) : (
                    /* Placeholder until real images are added */
                    <div className="cs-subcat-img-placeholder">
                      <span>{item.name}</span>
                    </div>
                  )}
                </div>

                {/* Card body */}
                <div className="cs-subcat-card-body">
                  <h3 className="cs-subcat-card-name">{item.name}</h3>
                  <p className="cs-subcat-card-hint">{item.hint}</p>
                </div>
              </div>
            ))}

            {/* Future slot */}
            <div className="cs-subcat-card cs-subcat-card--future">
              <div className="cs-subcat-future-inner">
                <span className="cs-future-plus">+</span>
                <span>More styles</span>
                <span className="cs-future-soon">Coming Soon</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="cs-coming-placeholder">
            <p>More styles coming soon — check back for updates!</p>
          </div>
        )}

      </div>
    </section>
  );
}

export default SubCategorySelector;
